export default "__VITE_ASSET__Bek65Mfm__"